import React from 'react';
import logoImage from '../../assets/images/logo.png'; // Adjust extension if needed

const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: 'h-10',
    default: 'h-14',
    large: 'h-16'
  };
  
  return (
    <div className={`flex items-center -mt-18 ${className}`}>
      <img 
        src={logoImage} 
        alt="ScriptWriter Logo" 
        className={`${sizes[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;